import { createAction } from '@reduxjs/toolkit';

export const setHistoryStocktakePage = createAction<number>('SET_HISTORY_STOCKTAKE_PAGE');